import React, { useState } from 'react'
import PropTypes from 'prop-types'
import QRCodeModalComponent from '../components/Hub/Components/QRCodeModal'

export const useQRCodeModal = () => {
  const [show, setShow] = useState(false)
  const [modalData, setModalData] = useState({
    hosted_url: null,
    expires_at: null,
    amount: null,
    is_in_test_mode: false
  })

  /**
   * Shows the QR code modal with payment data
   * @param {string} hostedUrl - The URL for the payment
   * @param {string} expiresAt - ISO timestamp when the payment link expires
   * @param {string|number} amount - The payment amount
   * @param {boolean} [isInTestMode=false] - Whether the payment is in test mode
   */
  const showQRCodeModal = (hostedUrl, expiresAt, amount, isInTestMode = false) => {
    setModalData({
      hosted_url: hostedUrl,
      expires_at: expiresAt,
      amount,
      is_in_test_mode: isInTestMode
    })
    setShow(true)
  }

  const hideQRCodeModal = () => {
    setShow(false)
    setModalData({
      hosted_url: null,
      expires_at: null,
      amount: null,
      is_in_test_mode: false
    })
  }

  const QRCodeModal = () => (
    <QRCodeModalComponent 
      show={show} 
      hide={hideQRCodeModal} 
      data={modalData}
      amount={modalData?.amount}
    />
  )

  return {
    QRCodeModal,
    showQRCodeModal,
  }
}

// PropTypes for the showQRCodeModal parameters
useQRCodeModal.propTypes = {
  hostedUrl: PropTypes.string.isRequired,
  expiresAt: PropTypes.string.isRequired,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isInTestMode: PropTypes.bool
} 
